module.exports = __webpack_public_path__ + "static/img/puting_2.50381fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/puting_2.png
// module id = bQzo
// module chunks = 1